import { render, staticRenderFns } from "./TextButtonBlock.vue?vue&type=template&id=311a4d80&scoped=true"
import script from "./TextButtonBlock.vue?vue&type=script&lang=js"
export * from "./TextButtonBlock.vue?vue&type=script&lang=js"
import style0 from "./TextButtonBlock.vue?vue&type=style&index=0&id=311a4d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a4d80",
  null
  
)

export default component.exports